<template>
  <section class="summary_list">
    <p class="summary_title">{{title}}</p>
    <flexbox :gutter="0" wrap="wrap" class="summary_data">
      <flexbox-item
        class="summary_item"
        v-for="(item, index) in titleList"
        :span="1/3"
        :key="index">
        <span class="summary_item_value">{{dataList[item.key]}}</span>{{item.name}}
      </flexbox-item>
    </flexbox>
  </section>
</template>
<script>
import { Flexbox, FlexboxItem } from '@lx-frontend/cvux'
export default {
  components: { Flexbox, FlexboxItem },
  props: {
    title: {
      type: String,
      default: '指标概览'
    },
    titleList: {
      type: Array,
      default() {
        return []
      }
    },
    dataList: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}

</script>
<style scoped lang="less">
@import '../../../stylesheets/base/fn';
.summary_list {
  background-color: #fff;
  padding: 40/@w2 30/@w2;
  .summary_title {
    color: #666666;
    font-size: 26/@w2;
    margin-bottom: 30/@w2;
  }
  .summary_data {
    border: 1px solid #d0d0d0;
    color: #999999;
    font-size: 26/@w2;
    .summary_item {
      text-align: center;
      padding-top: 34/@w2;
      padding-bottom: 34/@w2;
      position: relative;
      &:before {
        content: " ";
        position: absolute;
        left: -2px;
        top: 0;
        width: 1px;
        height: 80%;
        border-right: 1px solid #D9D9D9;
        color: #D9D9D9;
        transform-origin: 0 0;
        transform: scaleY(0.5);
        top: 0.6rem;
      }
      &:after {
        content: " ";
        position: absolute;
        left: 0px;
        top: 0;
        width: 100%;
        height: 200%;
        border-bottom: 1px solid #D9D9D9;
        color: #D9D9D9;
        transform-origin: 0 0;
        transform: scaleY(0.5);
      }
      .summary_item_value {
        color: #333333;
        font-size: 40/@w2;
        line-height: 40/@w2;
        display: block;
        margin-bottom: 20/@w2;
      }
    }
  }
}

</style>
